// Treat Reducers as State Machines
// https://redux.js.org/style-guide/style-guide#treat-reducers-as-state-machines

const IDLE = "idle";
const LOADING = "loading";
const SUCCESS = "success";
const FAILURE = "failure";

export { IDLE, LOADING, SUCCESS, FAILURE };
